<template>
	<c-dialog ref="dialog" enable-flex width="700" height="510" @resolve="submitHandle">
		<c-tab-list v-show="tabList.length > 1" ref="tabList" :tabs="tabList" type="border-tab" @change="data => currentTab = data.value"></c-tab-list>
		<c-form v-show="currentTab == 1" ref="form" unit-width="100%">
			<c-form-item v-show="baseInfo" label="标题" required>
				<c-select name="title_field_list" :options="titleField" multiple :clear="false"></c-select>
			</c-form-item>
			<c-form-item v-show="baseInfo" label="封面" required>
				<c-select name="cover_field_id" :options="coverField" :clear="false"></c-select>
			</c-form-item>
			<c-form-item v-show="baseInfo" label="指标" required>
				<c-select name="count_field_id" :options="countField" :clear="false"></c-select>
			</c-form-item>
			<c-form-item label="展示字段" required>
				<c-transfer name="field_list" :options="listField" search :title="['全部字段', '已选字段']" sort></c-transfer>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	export default {
		name: 'appViewConfig',

		props: {
			viewId: [Number, String],
			statistic: Boolean
		},

		data() {
			return {
				currentTab: 1,
				baseInfo: true,
				titleField: [],
				coverField: [],
				countField: [],
				listField: []
			}
		},

		computed: {
			tabList() {
				let list = [{
					name: '卡片配置',
					value: 1
				}];

				if (this.statistic) {
					list.push({
						name: '统计指标',
						value: 2
					});
				}

				return list;
			}
		},
		
		methods: {
			open(data) {
				this.$refs.dialog.open({
					title: `手机端${data.name}卡片配置`
				});
				this.baseInfo = data.baseInfo;
				this.request({
					url: '/sys_app_view/field_config',
					data: {
						view_id: this.viewId
					},
					loading: true,
					success: data => {
						this.$refs.form.set({
							title_field_list: data.title_field_list.map(item => item.field_id),
							cover_field_id: data.cover_field ? data.cover_field.field_id : '0',
							count_field_id: data.count_field ? data.count_field.field_id : '0',
							field_list: data.field_list.map(item => item.field_id)
						});
					}
				});

				['title', 'cover', 'count', 'list'].forEach((type, index) => {
					this[`${type}Field`] = [];
					this.request({
						url: '/sys_app_view/field_list',
						data: {
							view_id: this.viewId,
							type
						},
						success: data => {
							this[`${type}Field`] = data.map(item => {
								return {
									name: item.field_title,
									value: item.field_id
								}
							});
							if ([1, 2].includes(index)) {
								this[`${type}Field`].unshift({
									name: '不展示',
									value: '0'
								});
							}
						}
					})
				})
			},

			submitHandle(stop, next) {
				stop();
				this.$refs.form.submit({
					url: '/sys_app_view/edit_config',
					rule: {
						title_field_list: [{
							type: 'empty',
							message: '青选择标题字段',
							skip: () => {
								return !this.baseInfo;
							}
						}],
						field_list: '请选择展示字段'
					},
					dataFormatter: data => {
						data.view_id = this.viewId;
						data.field_list = data.field_list.map(item => {
							return {
								field_id: item
							}
						});
						return data;
					},
					success: () => {
						this.$message({
							message: '提交成功'
						});
						next();
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>